import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Grid } from '@material-ui/core';
import { FarmRiskType, lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import withDatePicker from 'core/components/with-date-picker';

import FO3RiskDetail from './FO3-risk-detail';
import FO4RiskDetail from './FO4-risk-detail';
import FO6RiskDetail from './FO6-risk-detail';

const riskTypeOptions = lookupsJson.farm.riskType;

const InitialRiskDetail = () => {
  const { values, setFieldValue } = useFormikContext();

  // Extract frequently accessed nested values to improve readability
  const farmLocation = values.farmLocations?.[0];
  const farmRisk = farmLocation?.risks?.[0];
  const farmLocationPath = 'farmLocations[0]';
  const farmRiskPath = `${farmLocationPath}.risks[0]`;

  useEffect(() => {
    if (farmRisk?.type === FarmRiskType.Fo6Scheduled || farmRisk?.type === FarmRiskType.Fo6Unscheduled) {
      setFieldValue(`${farmRiskPath}.address`, farmLocation?.address);
      setFieldValue(`${farmRiskPath}.city`, farmLocation?.address?.city);
      setFieldValue(`${farmRiskPath}.state`, farmLocation?.address?.state);
      setFieldValue(`${farmRiskPath}.zip`, farmLocation?.address?.zip);
      setFieldValue(`${farmRiskPath}.county`, farmLocation?.address?.county);
    }
  }, [farmRisk?.type, farmLocation?.address]);

  return (
    <Grid container spacing={2}>
      <Field
        xs={6}
        type="select"
        id="farmRiskType"
        name={`${farmRiskPath}.type`}
        mode="light"
        label="Risk Type*"
        options={riskTypeOptions}
        onChange={(value) => {
          if (value === FarmRiskType.Fo6Scheduled) {
            setFieldValue(`${farmRiskPath}.description`, 'FO6 Scheduled');
          }

          if (value === FarmRiskType.Fo6Unscheduled) {
            setFieldValue(`${farmRiskPath}.description`, 'FO6 Unscheduled');
          }
        }}
      />
      <Field
        xs={6}
        type="string"
        id="farmRisk.description"
        name={`${farmRiskPath}.description`}
        mode="light"
        label="Risk Name"
        disabled={farmRisk?.type === FarmRiskType.Fo6Scheduled || farmRisk?.type === FarmRiskType.Fo6Unscheduled}
      />

      {farmRisk?.type === FarmRiskType.Fo3 && <FO3RiskDetail />}

      {farmRisk?.type === FarmRiskType.Fo4 && <FO4RiskDetail />}

      {farmRisk?.type === FarmRiskType.Fo6Structures && <FO6RiskDetail />}
    </Grid>
  );
};

export default withDatePicker(InitialRiskDetail);
